import React from 'react';
import { Tooltip } from 'antd';

const generateDropdownMenuItems = ({
    selectedCount,
    currentPageCount,
    total,
    onSelectPage,
    onSelectAll,
    onSelectNone,
    isSelectAllLimited = false,
}) => [
    {
        label: `${selectedCount} items selected`,
        className: "table-selection-count",
        key: "selectedItems",
    },
    {
        type: 'divider'
    },
    {
        label: `Select page (${currentPageCount})`,
        key: "selectPage",
        onClick: onSelectPage
    },
    {
        type: 'divider'
    },
    {
        label: isSelectAllLimited ? (
            <Tooltip title="Select all is limited to 500 documents. Refine your filters or select documents in smaller groups">
                <span>{`Select all (${total})`}</span>
            </Tooltip>
        ) : `Select all (${total})`,
        key: "selectAll",
        onClick: onSelectAll,
        disabled: isSelectAllLimited,
    },
    {
        type: 'divider'
    },
    {
        label: "Select none",
        key: "selectNone",
        onClick: onSelectNone
    },
];

export default generateDropdownMenuItems 